import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import parse from "html-react-parser"
import resetIcon from "images/icons/icon-reset.svg?raw"

export default class RetryOptions extends Component {
  state = {
    failedResolutionCount: 0,
  }

  constructor(props) {
    super(props)

    this.doRetry = this.doRetry.bind(this)
  }

  doRetry(e) {
    e.preventDefault()

    this.setState({
      failedResolutionCount: this.state.failedResolutionCount + 1,
    })
    this.props.onRetry()
  }

  render() {
    const { failed, isOnColor, loading, serviceName } = this.props
    const { failedResolutionCount } = this.state

    const message = failed
      ? `${serviceName} seems to be down right now.`
      : `${serviceName} doesn't have any available options.`

    // The counter tracks how many attempts the user has already spent; it would
    // read as a countdown next to the in-flight label, so it waits for the reply.
    const counter =
      !loading && failedResolutionCount > 0 ? ` (${failedResolutionCount})` : ""

    return (
      <>
        <span>{message}</span>
        <button
          type="button"
          className={classnames("button-tiny", "button-compact", "button-with-icon", {
            "button-on-color": isOnColor,
          })}
          disabled={loading}
          onClick={this.doRetry}
        >
          <span className="button-icon">{parse(resetIcon)}</span>
          <span>
            {loading ? "Refreshing…" : "Refresh options"}
            {counter}
          </span>
        </button>
      </>
    )
  }
}

RetryOptions.propTypes = {
  failed: PropTypes.bool,
  isOnColor: PropTypes.bool,
  loading: PropTypes.bool,
  serviceName: PropTypes.string,
  onRetry: PropTypes.func,
}
